
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sports/ipl/[slug]/commentary",
      function () {
        return require("private-next-pages/sports/ipl/[slug]/commentary/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sports/ipl/[slug]/commentary"])
      });
    }
  